import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../scss/dashboard.scss';
import Header from '../components/header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup, faWater } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import BaseURL from '../assets/contants/BaseURL';
import Spinner from '../components/Spinner';


const LevelTank = ({ level = 0, maxLevel = 100 }) => {
    const tankPercentage = Math.max(0, Math.min(100, (level / maxLevel) * 100));
    const levelHeight = `${tankPercentage}%`;

    return (
        <div style={{ position: 'relative', width: '200px', height: '280px', margin: 'auto' }}>
            {/* Digital Display */}
            <div style={{
                position: 'absolute',
                top: -5,
                left: 5,
                width: '120px',
                height: '70px',
                backgroundColor: '#ccc',
                border: '2px solid #888',
                borderRadius: '6px',
                padding: '6px',
                boxSizing: 'border-box'
            }}>
                <div style={{
                    backgroundColor: 'black',
                    color: 'red',
                    fontSize: '20px',
                    textAlign: 'center',
                    padding: '4px',
                    borderRadius: '4px'
                }}>
                    {level.toFixed(1)}
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '6px' }}>
                    <button style={{ fontSize: '6px' }}>▲</button>
                    <button style={{ fontSize: '6px' }}>▼</button>
                    <button style={{ fontSize: '6px' }}>ESC</button>
                    <button style={{ fontSize: '6px' }}>ENT</button>
                </div>
            </div>

            {/* Wire to Sensor */}
            <div style={{
                position: 'absolute',
                top: 65,
                left: 50,
                width: '4px',
                height: '28px',
                backgroundColor: '#333'
            }} />
            <div style={{
                position: 'absolute',
                top: 90,
                left: 50,
                width: '50px',
                height: '4px',
                backgroundColor: '#333'
            }} />

            {/* Tank body */}
            <div style={{
                position: 'absolute',
                bottom: '-50px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '130px',
                height: '200px',
                border: '4px solid #888',
                borderRadius: '15px',
                backgroundColor: '#fff',
                overflow: 'hidden'
            }}>
                {/* Water level */}
                <div style={{
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                    height: levelHeight,
                    backgroundColor: '#69b3f9',
                    transition: 'height 1s ease-in-out'
                }}></div>
            </div>

            {/* Sensor on top of tank */}
            <div style={{
                position: 'absolute',
                top: 90,
                left: '50%',
                transform: 'translateX(-50%)',
                width: '30px',
                height: '35px',
                backgroundColor: '#ccc',
                border: '2px solid #555'
            }} />
            <div style={{
                position: 'absolute',
                top: 75,
                left: '50%',
                transform: 'translateX(-50%)',
                width: '30px',
                height: '15px',
                backgroundColor: 'darkgreen',
                border: '2px solid #333'
            }} />
            <div style={{
                position: 'absolute',
                top: 125,
                left: '50%',
                transform: 'translateX(-50%)',
                width: '8px',
                height: '45px',
                backgroundColor: '#bbb'
            }} />
        </div>
    );
};

const LevelPortal = () => {
    const navigate = useNavigate();
    const [levelData, setLevelData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [colors, setColors] = useState({});

    const getColorForMeter = (meterId) => {
        if (!colors[meterId]) {
            const hue = Math.floor(Math.random() * 360);
            const saturation = 70 + Math.floor(Math.random() * 30);
            const lightness = 40 + Math.floor(Math.random() * 30);
            const newColor = `hsl(${hue}, ${saturation}%, ${lightness}%)`;

            setColors(prev => ({ ...prev, [meterId]: newColor }));
            return newColor;
        }
        return colors[meterId];
    };

    useEffect(() => {
        const fetchLevelData = async () => {
            setLoading(true);
            try {
                const today = new Date();
                const indiaTime = new Date(today.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
                const formattedDate = `${indiaTime.getFullYear()}-${(indiaTime.getMonth() + 1).toString().padStart(2, '0')}-${indiaTime.getDate().toString().padStart(2, '0')}`;

                const response = await axios.post(`${BaseURL}data/waterlevel-table/`, {
                    date: formattedDate,
                });

                setLevelData(response.data);
            } catch (error) {
                console.error("Error fetching water level data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchLevelData();
    }, []);

    const handleMeterClick = (meterId) => {
        navigate("/EMS/Levelsub", { state: { meterId } });
        window.scrollTo(0, 0);
    };

    const handleMainClick = (type) => {
        if (type === "meters") {
            navigate("/EMS/Levelmeter");
        }
    };

    const renderWidget = (title, value, icon, onClick, color = '#0093ff') => (
        <div
            onClick={onClick}
            style={{
                width: '150px',
                height: '80px',
                margin: '10px',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-start',
                borderRadius: '15px',
                border: '1px solid #ddd',
                boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
                position: 'relative',
                textAlign: 'left',
                padding: '15px',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                backgroundColor: color
            }}
            className="widgetss"
        >
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                {icon && <FontAwesomeIcon icon={icon} size="3x" style={{ color: '#fff' }} />}
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <h4 style={{ margin: 0, fontSize: '0.9rem', fontWeight: 'bold', color: '#fff' }}>{title}</h4>
                    <p style={{ fontSize: '1rem', color: '#fff', fontWeight: '400' }}>{value}</p>
                </div>
            </div>
        </div>
    );

    const renderSummaryWidgets = () => {
        if (!levelData) return null;
        
        return (
            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '20px',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: '20px',
            }}>
                {renderWidget(
                    'Total Meters', 
                    levelData.total_water_level_meters, 
                    faLayerGroup, 
                    () => handleMainClick('meters'),
                    '#4a6baf'
                )}
                {renderWidget(
                    'Todays Total Water Level', 
                    `${(levelData.total_water_level).toLocaleString(undefined, {minimumFractionDigits: 0,maximumFractionDigits: 0})} m`, 
                    faWater, 
                    null,
                    '#3aa8a1'
                )}
            </div>
        );
    };

    const renderMeterWidgets = () => {
        if (!levelData?.water_level_meters) return null;

        return (
            <div style={{ marginBottom: '20px' }}>
                <div style={{
                    width: '100%',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '20px',
                    justifyContent: 'center',
                }}>
                {levelData.water_level_meters.map((meter) => (
                    <div
                        key={meter.meter_id}
                        onClick={() => handleMeterClick(meter.meter_id)}
                        style={{
                                width: '600px',
                                height: '450px',
                                background: '#047BC4',
                                borderRadius: '10px',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                padding: '20px',
                                boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                                textAlign: 'center',
                                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                cursor: 'pointer',
                            }}
                            className="widgetss"
                    >
                        <h4 style={{
                            margin: '5px 0',
                            color: '#fff',
                            textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
                            fontSize: '18px',
                        }}>
                            {meter.meter_name}
                        </h4>
                        <LevelTank
                            level={meter.current_water_level || 0}
                            maxLevel={100}
                        />
                        <p
                                style={{
                                    margin: '0',
                                    color: '#fff',
                                    fontWeight: '600',
                                    textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
                                    fontSize: '12px',
                                }}
                            >
                                Current Level: {(meter.current_water_level).toLocaleString(undefined, {minimumFractionDigits: 0,maximumFractionDigits: 0})} m
                            </p>
                            <p
                                style={{
                                    margin: '0',
                                    color: '#fff',
                                    fontWeight: '600',
                                    textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
                                    fontSize: '12px',
                                }}
                            >
                                Todays Level: {(meter.daily_max_water_level).toLocaleString(undefined, {minimumFractionDigits: 0,maximumFractionDigits: 0})} m
                            </p>
                    </div>
                ))}
            </div>
            </div>
        );
    };

    return (
        <div className="dashboard-container">
            <Header title="BRADKEN WATER LEVEL MONITORING DASHBOARD" />
            <div className="card-container" style={{
                border: '1px solid #ccc',
                borderRadius: '10px',
                padding: '20px',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                backgroundColor: '#fff',
                marginTop: '50px',
                maxWidth: '1200px',
                marginLeft: 'auto',
                marginRight: 'auto'
            }}>
                <div className="card" style={{ background: '#fff', borderRadius: '10px' }}>
                    {loading ? (
                        <div className="loading-spinner">
                            <Spinner />
                        </div>
                    ) : (
                        <>
                            {renderSummaryWidgets()}
                            <h3 className="dashboard-subtitle" style={{ textAlign: 'center', margin: '20px 0' }}>
                                Water Level Meters
                            </h3>
                            {renderMeterWidgets()}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default LevelPortal;